import React, { useEffect, useState } from "react";
import { t } from "i18next";
import Grid2 from "@mui/material/Unstable_Grid2";
import { TextField, debounce } from "@mui/material";
import { MuiDateRangePicker } from "../../framework/muiDatepicker";
import { CustomerSelect } from "../components/customerSelect";
import { getCustomerDetails } from "../../../services/customerService";
import { showApiError } from "../../framework/formUtils";
import { ICustomerDetails } from "../../../models/customer/customerDetails";

export interface TransportOrderFiltersProps {
    filterCustomer: string;
    setFilterCustomer: (customerId: string) => void;
    timeRange: [Date, Date];
    setTimeRange: (timeRange: [Date, Date]) => void;
    setKeyword: (keyword: string) => void;
    disabledCustomer?: boolean;
    selectedInvoiceCustomerId?: string;
}

export const TransportOrderFilters = ({
    filterCustomer,
    setFilterCustomer,
    timeRange,
    setTimeRange,
    setKeyword,
    disabledCustomer,
    selectedInvoiceCustomerId,
}: TransportOrderFiltersProps) => {
    const [selectedCustomer, setSelectedCustomer] = useState<ICustomerDetails>();

    const debouncedSetKeyword = debounce((value: string) => {
        setKeyword(value);
    }, 1000);

    useEffect(() => {
        if (selectedInvoiceCustomerId) {
            getCustomerDetails(selectedInvoiceCustomerId)
                .then((res) => {
                    setSelectedCustomer(res.data);
                })
                .catch((error) => {
                    showApiError(error.message);
                });
        }
    }, [selectedInvoiceCustomerId]);

    return (
        <div>
            <Grid2 container spacing={2}>
                <Grid2>
                    <MuiDateRangePicker
                        labels={[t("common.dateRangeStart"), t("common.dateRangeEnd")]}
                        value={timeRange}
                        onChange={setTimeRange}
                    />
                </Grid2>
                <Grid2>
                    {disabledCustomer ? (
                        <TextField
                            value={selectedCustomer?.name}
                            label={t("customer.customer")}
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                readOnly: true,
                            }}
                            disabled
                        />
                    ) : (
                        <CustomerSelect
                            value={filterCustomer}
                            onChange={setFilterCustomer}
                            disabled={disabledCustomer}
                        />
                    )}
                </Grid2>
                <Grid2>
                    <TextField
                        label={t("common.search")}
                        onChange={(e) => debouncedSetKeyword(e.currentTarget.value)}
                    />
                </Grid2>
            </Grid2>
        </div>
    );
};
